/**
 * PartnerPortalApp — Main routing component
 *
 * Registered in flux-web at /partner/*
 * Gated by ModuleRoute with requiredProduct="partner_portal"
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WizardPage from './WizardPage';
import ProposalsPage from './ProposalsPage';

function PartnerPortalApp() {
  return (
    <Routes>
      {/* Default: New Proposal wizard */}
      <Route index element={<WizardPage />} />

      {/* Past proposals */}
      <Route path="proposals" element={<ProposalsPage />} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/partner" replace />} />
    </Routes>
  );
}

export default PartnerPortalApp;
